import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import HeadInfo from '../../components/layout/HeadInfo'
import { toggleLoginForm } from '../../actions/appActions'
import { logout } from '../../actions/accountActions'
import AccountModalContainer from '../auth/AccountModalContainer'
import UpdatePasswordModalContainer from '../auth/UpdatePasswordModalContainer'
import LoginContainer from '../LoginContainer'
import ForgotPasswordContainer from '../auth/ForgotPasswordContainer'

const HeadInfoContainer = ({ toggleSidebar, toggleAdrMgr }) => {
    const dispatch = useDispatch()
    const restaurantInfo = useSelector(state => state.RestaurantReducer)
    const user = useSelector(state => state.AccountReducer.user)

    const [showAccountModal, setShowAccountModal] = useState(false)
    const [showUpdatePassword, setShowUpdatePassword] = useState(false)
    const [showForgotPassword, setShowForgotPassword] = useState(false)

    const openLoginForm = () => {
        dispatch(toggleLoginForm(true))
    }

    const handleLogout = () => {
        dispatch(logout())
    }

    return (
        <>
            <HeadInfo
                toggleSidebar={toggleSidebar}
                toggleAdrMgr={toggleAdrMgr}
                handleLogout={handleLogout}
                openLogin={openLoginForm}
                restaurantInfo={restaurantInfo}
                user={user}
                setShowAccountModal={setShowAccountModal}
                setShowUpdatePassword={setShowUpdatePassword}
            />

            <AccountModalContainer
                isOpen={showAccountModal}
                setIsOpen={setShowAccountModal}
            />

            <UpdatePasswordModalContainer
                isOpen={showUpdatePassword}
                setIsOpen={setShowUpdatePassword}
            />

            <ForgotPasswordContainer
                isModal
                isOpen={showForgotPassword}
                setIsOpen={setShowForgotPassword}
            />

            <LoginContainer
                setShowAccountModal={setShowAccountModal}
                setShowForgotPassword={setShowForgotPassword}
            />
        </>
    )
}

export default HeadInfoContainer
